<template>
  <!-- Desktop version -->
  <Motion
    as="div"
    :initial="{ opacity: 0, y: 20 }"
    :animate="{ opacity: 1, y: 0 }"
    :whileHover="{
      scale: 1.02,
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
      filter: 'brightness(0.9)',
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      }
    }"
    :transition="{
      duration: 0.5,
      backgroundColor: {
        delay: motionDelay / 1000,
      },
      opacity: {
        delay: motionDelay / 1000,
      },
      y: {
        delay: motionDelay / 1000,
      },
      ease: 'easeOut'
    }"
    class="flex flex-col justify-between new_lg:col-start-4 new_lg:col-end-5 new_lg:row-start-1 new_lg:row-end-[4] bg-[rgb(250,236,215)] rounded-[20px] font-basic cursor-pointer new_lg:py-6 py-4 new_lg:px-5 px-4 relative overflow-hidden"
    @click="goToPage"
  >
    <!-- 상단: Title -->
    <div class="flex items-center justify-between">
      <p class="font-normal font-basic text-sm new_sm:text-lg new_lg:text-xl new_2xl:text-[26px] tracking-tight">
        문의사항이 있나요?
      </p>
      <img
        :src="require('@/assets/ic-plane-black.png')"
        alt="contact"
        class="w-4 h-4 new_sm:w-12 new_sm:h-12"
      />
    </div>

    <!-- 하단: Subtitle -->
    <div>
      <p class="font-semibold font-paperlogy text-xl new_sm:text-3xl new_xl:text-4xl new_2xl:text-5xl whitespace-pre-wrap">Contact Us</p>
    </div>
  </Motion>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useResponsive } from '@/composables/useResponsive'
import { Motion } from 'motion-v'

defineProps({
  motionDelay: {
    type: Number,
    default: 0
  }
})

const router = useRouter()

// Responsive state
const { isMobile } = useResponsive()

const goToPage = () => {
  router.push('/contactus')
}
</script>
